import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { RequiredAccountRow } from "../requiredAccountsMapping";
import styles from "../RequiredAccountsMapping.module.scss";

type TextField = "description";

export const createRequiredAccountTextCell = ({
    field,
    className,
}: {
    field: TextField;
    className: string;
}) => {
    const RequiredAccountTextCell = memo(
        ({
            row,
        }: CellContext<ViewTableFeatures, RequiredAccountRow, unknown>) => (
            <ViewTableCell className={styles.textCell}>
                <span className={className}>{row.original[field]}</span>
            </ViewTableCell>
        ),
    );
    RequiredAccountTextCell.displayName = `RequiredAccountTextCell(${field})`;
    return RequiredAccountTextCell;
};
